import fireErrorAnalytics, {
	type AnalyticsPayload,
} from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { fireErrorAnalyticsCommon } from '@atlassian/jira-issue-commmon-error-boundary/src/utils/fire-error-analytics/index.tsx';

export const fireIssueTransitionErrorAnalytics = (payload: AnalyticsPayload) => {
	if (!fg('issue-transition-fire-error-analytics-refactor')) {
		return fireErrorAnalytics(payload);
	}
	const { attributes = {}, error, ...otherPayload } = payload;

	fireErrorAnalyticsCommon({
		...otherPayload,
		attributes: {
			...attributes,
		},
		error,
	});
};
